var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewplay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2vw",
    height: "1.2vw",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83472 7.37988C7.84822 7.26635 7.88802 7.15754 7.95096 7.06209C8.0139 6.96664 8.09823 6.88719 8.19726 6.83005C8.29629 6.77292 8.40728 6.73967 8.52142 6.73296C8.63555 6.72624 8.74967 6.74625 8.85472 6.79138C9.38572 7.01838 10.5757 7.55788 12.0857 8.42938C13.5962 9.30138 14.6587 10.0629 15.1202 10.4084C15.5142 10.7039 15.5152 11.2899 15.1207 11.5864C14.6637 11.9299 13.6142 12.6814 12.0857 13.5644C10.5557 14.4474 9.37972 14.9804 8.85372 15.2044C8.40072 15.3979 7.89372 15.1044 7.83472 14.6159C7.76572 14.0449 7.63672 12.7484 7.63672 10.9974C7.63672 9.24738 7.76522 7.95138 7.83472 7.37988Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewplay);
export default __webpack_public_path__ + "static/media/newplay.a00d1751dad35b72b9bdc5c1c85b140c.svg";
export { ForwardRef as ReactComponent };